const faqs = [
  {
    q: '大师兄影视需要注册才能观看吗？',
    a: '无需注册即可直接观看！大师兄影视主打便捷观影体验，打开网站就能浏览海量片库，点击即播。注册账号后可享受收藏、历史记录、多设备同步等更多个性化功能。',
  },
  {
    q: '播放视频会卡顿或缓冲吗？',
    a: '大师兄影视采用先进的不缓冲秒开播放技术，配合极速加载流畅观影引擎，正常情况下视频加载迅速、播放流畅。实际体验受您的网络环境影响，建议使用稳定的WiFi或4G/5G网络。',
  },
  {
    q: '支持哪些设备观看？',
    a: '大师兄影视全面支持PC电脑、手机浏览器、平板以及智能电视。我们还提供移动客户端App（Android与iOS），安装后可享受离线缓存、多设备续播等专属功能，一次观看、多端接力。',
  },
  {
    q: '片库更新频率如何？',
    a: '大师兄影视片库每日持续更新，热播剧集通常上线后24小时内完成同步，电影和综艺也会在第一时间跟进。首页「最新动态」模块会实时展示最新上线内容。',
  },
  {
    q: '视频画质怎么样？支持高清吗？',
    a: '大师兄影视提供多种清晰度选项，包括高清720P、全高清1080P以及部分片源的4K超高清。您可以根据网络状况和设备性能自由切换画质，获得最佳观影体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="relative py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">常见问题</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">关于大师兄影视，您可能想了解的信息</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-200/50 rounded-xl border border-background-200/60 overflow-hidden">
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-4">
                  <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400 text-sm font-bold mt-0.5">
                    Q
                  </span>
                  <div>
                    <h3 className="text-foreground-100 font-semibold text-sm md:text-base mb-2">{faq.q}</h3>
                    <p className="text-foreground-500 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}